export default ({ data, headers }) => data.map((d) => {
    const item = {};
    headers.forEach((h, i) => {
      item[h] = d[i];
    });
    return item;
  });
